export const getValue = (obj: any, key: string) => {
    if (!obj) return undefined;
    return typeof obj.get === "function" ? obj.get(key) : obj[key];
};
